import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import { getSessionData } from "../../sessionData/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { apiRequest } from '../../api/actions';
import { HttpConstants } from "../../../../constants/HttpConstants";
import { setSoftElectroSubmitMessageAction, setSoftElectroSubmitStatusAction } from "./actions";
import _ from "lodash";
import { CampaignConstants } from "../../../../constants/CampaignConstants";

export const campaignSoftElectroResendOfferMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.SOFT_ELECTRO.RESEND_OFFER:
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS}/resend`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.RESEND_OFFER,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.RESEND_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.RESEND_OFFER} ${ActionTypes.API_SUCCESS}` :
    next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.SUCCESS));
    next(setSoftElectroSubmitMessageAction(action.payload.data.message));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.RESEND_OFFER));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.RESEND_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.RESEND_OFFER} ${ActionTypes.API_ERROR}` :
    next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.GENERAL_ERROR));
    next(setSoftElectroSubmitMessageAction('Došlo je do neočekivane greške tokom procesa ponovnog slanja ponude.'));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.RESEND_OFFER));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.RESEND_OFFER));
    break;
  }
};

export const campaignSoftElectroCancelOfferMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.SOFT_ELECTRO.CANCEL_OFFER:
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS}/cancel`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.CANCEL_OFFER,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.CANCEL_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.CANCEL_OFFER} ${ActionTypes.API_SUCCESS}` :
    next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.SUCCESS));
    next(setSoftElectroSubmitMessageAction(action.payload.data.message));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.CANCEL_OFFER));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.CANCEL_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.CANCEL_OFFER} ${ActionTypes.API_ERROR}` :
    next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.GENERAL_ERROR));
    next(setSoftElectroSubmitMessageAction('Došlo je do neočekivane greške tokom procesa ponovnog slanja ponude.'));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.CANCEL_OFFER));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.CANCEL_OFFER));
    break;
  }
};

export const campaignSoftElectroSendNewOfferMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.SOFT_ELECTRO.SEND_NEW_OFFER:
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS}/sendNew`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER} ${ActionTypes.API_SUCCESS}` :
    if (_.has(action.payload, 'sendSmsForSoftRenewalResponse')) {
      next(setSoftElectroSubmitStatusAction(action.payload.data.sendSmsForSoftRenewalResponse.code));
      next(setSoftElectroSubmitMessageAction(action.payload.data.sendSmsForSoftRenewalResponse.message));
    } else {
      next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.GENERAL_ERROR));
      next(setSoftElectroSubmitMessageAction('Došlo je do greške. Nepoznat status akcije.'));
    }
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER));
    break;
  case `${MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER} ${ActionTypes.API_ERROR}` :
    next(setSoftElectroSubmitStatusAction(CampaignConstants.softElectro.submitCodes.GENERAL_ERROR));
    next(setSoftElectroSubmitMessageAction('Došlo je do neočekivane greške. Nepoznat status akcije. Molimo pokušajte ponovo.'));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.SEND_NEW_OFFER));
    break;
  }
};

export const campaignSoftElectroMiddleware = [
  campaignSoftElectroResendOfferMiddleware,
  campaignSoftElectroCancelOfferMiddleware,
  campaignSoftElectroSendNewOfferMiddleware
];
